export default {
  SET_SETTINGS: function (state, payload) {
    state.settings = payload;
  }
}
